import { urlBsa, urlEmpresa, urlFlujoArt, urlInitial } from '@/helpers';
import { httpInstance } from '@/clients/http.request';

export const getCompanyIcon = async (_context, { id_empresa, esPng } = {}) => {
   return getCompanyIconRequest({ id_empresa, esPng });
};

export const getInitialData = async (state) => {
   const id_empresa = state.rootState.auth.usuario.id_empresa;

   try {
      const { data } = await httpInstance.get(`${urlInitial}`);
      state.commit('setInitialData', data);
      const resArtEstados = await httpInstance.get(`${urlFlujoArt}/estadosArt`);
      state.commit('art/setEstadosArt', resArtEstados.data, { root: true });
      const artCompanies = await httpInstance.get(
         `${urlBsa}/getCompaniesBySection/${id_empresa}/${2}`, //! se le pasa el id_empresa y el id_seccion
      );
      state.commit('art/setArtCompanies', artCompanies.data, { root: true });
      state.commit('bsa/setEstados', data.estados, { root: true });

      // El logo del header lo resuelve `useContextualLogo`, que reacciona al
      // commit de `sections` de arriba. No lo pedimos acá para no competir.
      state.commit('setLoading', false);

      return { ok: true };
   } catch (error) {
      return { ok: false, message: 'Error al buscar información inicial' };
   }
};

export const getCiasBySeccion = async ({ commit }, id_seccion) => {
   try {
      const { data } = await httpInstance.post(
         `${urlInitial}/companiaSection/${id_seccion}`,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const getCompaniesBySeccion = async ({ rootState }, id_seccion) => {
   const id_empresa = rootState.auth.usuario.id_empresa;
   const { data } = await httpInstance.get(
      `${urlBsa}/getCompaniesBySection/${id_empresa}/${id_seccion}`,
   );
   return data;
};

export const getDepartamentosById = async ({ commit, state }, id_provincia) => {
   try {
      const { data } = await httpInstance.get(
         `${urlInitial}/departamentos/${id_provincia}`,
      );

      commit('setDepartamentos', {
         id_provincia,
         departamentos: data,
      });
   } catch (error) {
      throw error;
   }
};

export const getLocalidadById = async (
   { commit, state },
   { id_provincia, id_departamento = null },
) => {
   try {
      const key = id_departamento
         ? `${id_provincia}_${id_departamento}`
         : `${id_provincia}`;

      if (state.localidades[key]) {
         return;
      }

      const endpoint = id_departamento
         ? `${urlInitial}/localidades/${id_provincia}/${id_departamento}`
         : `${urlInitial}/localidades/${id_provincia}`;

      const { data } = await httpInstance.get(endpoint);

      commit('setLocalidades', {
         id_provincia,
         id_departamento,
         localidades: data,
      });
   } catch (error) {
      throw error;
   }
};

export const getEmpresasGrupo = async ({ commit }) => {
   try {
      const { data } = await httpInstance.get(`${urlInitial}/empresasGrupo`);
      commit('setEmpresasGrupo', data);
   } catch (error) {
      throw error;
   }
};
export const getSucursalesEmpresa = async ({ commit }, id_empresa) => {
   try {
      const { data } = await httpInstance.post(
         `${urlInitial}/sucursalesEmpresa`,
         id_empresa,
      );
      commit('setSucursalesGrupo', data);
   } catch (error) {
      throw error;
   }
};

/**
 * Petición centralizada al endpoint de icono de empresa.
 * @param {{ id_empresa?: number, esPng?: boolean }} params - id_empresa para icono de una empresa concreta; esPng para formato PNG (p. ej. PDFs).
 * @returns {Promise<{ data: ArrayBuffer, mimeType: string }>}
 */
export const getCompanyIconRequest = async ({ id_empresa, esPng } = {}) => {
   const params = {};
   if (id_empresa != null) params.id = id_empresa;
   // Only send esPng when true — query string "false" is truthy on the backend.
   if (esPng === true) params.esPng = true;

   const response = await httpInstance.getFileEmail(
      `${urlEmpresa}/icon`,
      params,
      { responseType: 'arraybuffer' },
   );

   const mimeType = esPng ? 'image/png' : 'image/svg+xml';
   return { data: response.data, mimeType };
};
